import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SmsEvident } from '../models/line-association.model';
import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { GeneralApiResponse } from '../core/models/general-api-response';

/**
 * Servicio para gestionar envío y validación de códigos SMS
 * Versión MOCK para desarrollo
 */
@Injectable({
  providedIn: 'root',
})
export class SmsEvidentService {
  private http = inject(HttpClient);
  private readonly evidentUrl = environment.evidentUrl;
  private readonly evidentBrandId: number = 1;
  private readonly evidentChannelId: number = 2;
  private readonly evidentMessage: string =
    '¡Jelou! usa {code} como codigo de verificacion para agregar la linea a tu cuenta. :)';

  /**
   * Genera y envía un código SMS de validación
   */
  generateCode(smsData: SmsEvident): Observable<GeneralApiResponse<void>> {
    const payload = {
      ...smsData,
      brand: { id: this.evidentBrandId },
      channel: {
        id: this.evidentChannelId,
      },
      message: this.evidentMessage,
    };
    return this.http.post<GeneralApiResponse>(`${this.evidentUrl}/sms-evident`, payload);
  }

  /**
   * Valida el código SMS ingresado
   */
  validateCode(smsData: SmsEvident): Observable<GeneralApiResponse<void>> {
    const payload = {
      ...smsData,
      brand: { id: this.evidentBrandId },
      channel: {
        id: this.evidentChannelId,
      },
    };

    return this.http.post<GeneralApiResponse>(`${this.evidentUrl}/sms-evident/validate`, payload);
  }
}
